import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const HeaderBox = styled(Box, { label: 'ToastContainerHeader' })(({ theme }) => ({
  display: 'flex',
  justifyContent: 'flex-end',
  alignItems: 'center',
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
}));

export const ToastContainerWrapper = styled(Paper, { label: 'ToastContainerWrapper' })(({ theme }) => ({
  position: 'fixed',
  top: '66px',
  right: '2px',
  minWidth: '392px',
  zIndex: theme.zIndex.tooltip,
  paddingTop: 0,
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(1),
  borderRadius: 0,
  boxShadow: 'none',
  backgroundColor: 'transparent',
  overflow: 'visible',
  cursor: 'move',
  transition: 'border-radius 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
  '& .Toastify__close-all': {
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },
  '&:hover': {
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[8],
    backgroundColor: theme.palette.background.paper,
    '& .Toastify__close-all': {
      opacity: 1,
    },
  },

  '&& .Toastify__toast-container': {
    position: 'static',
    padding: 0,
    margin: 0,
  },
  '&& .Toastify__toast': {
    pointerEvents: 'auto',
    cursor: 'default',
  },
  // redefines default animatiion duration
  '&& .Toastify__zoom-exit': {
    animationDuration: '0.2s',
  },
  // redefines default animatiion duration
  '&& .Toastify__zoom-enter': {
    animationDuration: '0.3s',
  },
  // prevents animation when draging
  '.react-draggable-transparent-selection &': {
    transition: 'none',
  },
}));
